<script lang="ts">
  import type { GatFormFieldLabelProps } from '../gat-form-field/gat-form-field-label.vue'
  import { globalUtils } from '@gat-ship/utils'
  export interface FieldRemovableProps extends GatFormFieldLabelProps {
    class?: HTMLAttributes['class']
    show: boolean
    dataTestid?: string
  }
</script>

<script setup lang="ts">
  import GatFormFieldLabel from '../gat-form-field/gat-form-field-label.vue'
  import GatButton from '../gat-button/gat-button.vue'
  import { onMounted, reactive, type HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'
  import { TooltipHint } from '../tooltips'

  const props = defineProps<FieldRemovableProps>()

  const boundEvents = reactive({
    show: false
  })

  const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
  }>()

  onMounted(() => {
    boundEvents.show =
      globalUtils.functions.components.hasEmitListener('update:show')
  })
</script>

<template>
  <div :class="cn('flex flex-col pb-1.5 pt-2.5', props.class)" v-if="show">
    <GatFormFieldLabel
      v-bind="{
        id: id,
        label: label,
        tooltipHint: undefined,
        showOptional: false,
        isError: isError
      }"
    >
      <template #default>
        <div class="flex items-end gap-0.5 pb-1.5">
          <span>{{ label }}</span>
          <TooltipHint v-if="tooltipHint" :text="tooltipHint" />
          <span
            v-if="showOptional !== false"
            class="text-soft text-xs font-normal"
            >optional</span
          >
        </div>
      </template>
      <template #append>
        <gat-button
          v-if="boundEvents.show"
          variant="outline"
          label="remove"
          size="sm"
          icon="X"
          icon-position="right"
          :icon-props="{ class: 'size-3' }"
          class="text-soft -mb-px h-6 gap-1 rounded-b-none border-neutral-300 bg-neutral-50 text-xs"
          :test-id="dataTestid"
          @click="emit('update:show', false)"
        >
          <span>remove</span>
        </gat-button>
      </template>
    </GatFormFieldLabel>
    <slot />
  </div>
  <div
    v-if="!show && $slots.trigger"
    v-bind="{
      onClick: () => emit('update:show', true)
    }"
  >
    <slot name="trigger" />
  </div>
</template>
